import { IconKey,IconUsers } from '@tabler/icons';

// constant
const icons = {
    IconKey,
    IconUsers
};
//

const Hr_Admin = {

    id: 'Hr_Admin',
    title: 'Hr and Admin',
    type: 'group',
    display_id:'M',
    icon: icons.IconUsers,
    children: [
        {
            id: 'Hr_Admin_dashboard',
            title: 'Code Activation',
            type: 'item',
            display_id:47,
            url: '/Department/Hr_admin/code_activation',
            breadcrumbs: false
        },
    ]
}

export default Hr_Admin;